
export class ErrInfo { 
  images?: ErrImage;
  ctaType?: string;
  errorCode?: string;
  title?: string;
  description?: string;
  ctaLink?: ErrCtaLink;
  ctaName?: string;
}
  
export class ErrImage { 
  BinaryContent: BinaryContents
}

export class BinaryContents { 
  url: string;
}
  
export class ErrCtaLink { 
  iosDeepLink?: string;
  webTarget?: string;
  webExternalLink?: string;
  androidDeepLink?: string;
}

export const ErrInfo_EN = {
  ctaName: "Refresh",
  ctaType: "refresh",
  description: "Sorry, the current page encountered a network problem, please try again",
  errorCode: "429",
  title: "Shanghai Disney Resort"
}

export const ErrInfo_ZH = {
  ctaName: "刷新",
  ctaType: "refresh",
  description: "抱歉，当前页面遇到网络问题，请重试",
  errorCode: "429",
  title: "上海迪士尼度假区"
}